import script from "./TaskTableDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTableDetail.vue?vue&type=script&setup=true&lang=js"

import "./TaskTableDetail.vue?vue&type=style&index=0&id=4a2dc3a9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2dc3a9"]])

export default __exports__